import {css} from "@emotion/react";
import {theme} from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const styles = {
    container: css`
        .slick-list {
            border-radius: 8px;
        }

        li {
            height: 8px;
            width: 12px;
            border-radius: 8px;
        }

        li.slick-active {
            width: 32px;
            background-color: ${theme.colors.purple[500]};

            div {
                display: none;
            }
        }

        .slick-prev:before, .slick-next:before {
            content: '';
        }

        .slick-prev {
            left: 0;
            z-index: 9;
            
            &:hover{
                background-color: ${theme.colors.purple[500]};
            }
        }

        .slick-next {
            right: 0;
            z-index: 9;

            &:hover{
                background-color: ${theme.colors.purple[500]};
            }
        }
    `,

    blog_container: css`
       
    
    `,
}

export default styles;